





































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ByPhoneLogin } from "@/req/password";
import { getPhoneCode, checkPhoneCode, logout } from "@/req/user";
@Component
export default class Logout extends Vue {
  public modal2 = false;
  public status = true;
  public loginShow = 11;
  public pwdshow = "icons/login3.png";
  public newPwdshow = "icons/login3.png";
  public flg = true;
  public newflg = true;
  public errorHint = false;
  public hint = false; // 提示弹框
  public isDisable = false;
  public smsCountTime = true;
  public countdown = 60;
  public timer: any = "";
  public exist = false;
  public existlog = false;
  public accord = false;
  public msgs = "手机号格式错误";
  public msgpwd = "密码号格式错误";
  public textC = false;
  public valId = "";
  public formLogin: any = {
    password: "",
    newpassword: "",
    phone: "",
    code: "",
  };
  public show(val) {
    this.valId = val;
    this.modal2 = true;
    this.loginShow = 11;
    this.errorHint = false;
    this.formLogin = {
      password: "",
      newpassword: "",
      phone: "",
      code: "",
    };
    this.formLogin.phone = this.$store.state.user.info.phone;
  }
  public drawVack() {
    this.errorHint = false;
    this.formLogin.code = "";
    if (!this.errorHint) return (this.loginShow = 5);
  }

  @Watch("formLogin", { deep: true })
  public handleWatch() {
    if (this.formLogin.phone !== "") {
      this.textC = true;
    } else {
      this.textC = false;
    }
    if (this.formLogin.password !== "" || this.formLogin.newpassword !== "") {
      this.exist = true;
    } else {
      this.exist = false;
    }
    if (this.formLogin.phone !== "" || this.formLogin.code !== "") {
      this.existlog = true;
    } else {
      this.existlog = false;
    }
  }

  public lognext() {
    this.isDisable = true;
    setTimeout(() => {
      this.isDisable = false;
    }, 3000);
    if (this.formLogin.password.length < 6)
      return this.msgTs("密码不能小于六位");
    if (this.formLogin.password !== this.formLogin.newpassword)
      return this.msgTs("两次输入的密码不一致");

    this.errorHint = false;
    this.login();
  }
  // 修改密码
  public async login() {
    const obj = {
      token: this.$fn.cookies.getToken(),
      phone: this.formLogin.phone,
      newpassword: this.formLogin.newpassword,
      repassword: this.formLogin.password,
      code: this.formLogin.code,
    };
    const res = await ByPhoneLogin(obj);
    if (res.code === 200) {
      this.$Message.success("修改成功");
      this.modal2 = false;
      this.loginOut();
    } else {
      this.msgTs(res.msg);
    }
  }
  public async loginOut() {
    const res = await logout({ token: this.$fn.cookies.getToken() });
    if (res.code == 200) {
      localStorage.removeItem("tempLogin");
      this.$fn.cookies.removeToken();
      this.$router.push({ path: "/home" });
    }
    (window as any).location.reload();
  }

  public msgTs(val) {
    this.errorHint = true;
    if (this.loginShow != 4) {
      this.msgs = val;
      return;
    }
    this.msgpwd = val;
  }

  public loginnext() {
    if (this.formLogin.phone === "") return this.msgTs("电话号码不能为空");
    if (this.formLogin.code === "") return this.msgTs("验证码不能为空");
    this.errorHint = false;
    this.checkCode();
  }

  // 获取焦点
  public foucs() {
    this.errorHint = false;
  }

  // 失去焦点
  public blur() {
    if (this.formLogin.phone.length < 6) {
      this.msgTs("手机号格式不正确");
      return;
    }
    this.errorHint = false;
  }
  public pwdblur() {
    if (this.formLogin.password.length < 6) {
      this.msgTs("密码小于6位");
      return;
    }
    this.errorHint = false;
  }
  public newpwdblur() {
    if (this.formLogin.password !== this.formLogin.newpassword) {
      this.msgTs("两次输入的密码不一致");
      return;
    }
    this.errorHint = false;
  }
  // 勾选提示
  public hintsh() {
    this.hint = true;
    setTimeout(() => {
      this.hint = false;
    }, 2000);
  }
  public clearBlank() {
    this.formLogin.phone = this.formLogin.phone.replace(/[^0-9]/g, "");
  }
  public clearSpace() {
    this.formLogin.password = this.formLogin.password.replace(
      /[^a-zA-Z0-9]/g,
      ""
    );
  }
  // 获取手机验证码
  public async gain() {
    if (!this.$fn.phoneFormat(this.formLogin.phone))
      return this.msgTs("手机号格式错误");
    const obj = {
      phone: this.formLogin.phone,
      event: 3,
    };
    const res = await getPhoneCode(obj);
    if (res.code == 200) {
      this.smsCountDown();
      this.smsCountTime = false;
    } else {
      this.msgTs(res.msg);
    }
  }
  // 校验手机验证码
  public async checkCode() {
    const obj = {
      phone: this.formLogin.phone,
      code: this.formLogin.code,
    };
    const res = await checkPhoneCode(obj);
    if (res.code == 200) {
      this.loginShow = 4;
      return;
    } else {
      this.msgTs(res.msg);
    }
  }
  // 短信验证码倒计时
  public smsCountDown() {
    const self = this;
    this.timer = setInterval(() => {
      self.countdown--;
      if (self.countdown === 0) {
        clearInterval(self.timer);
        self.countdown = 60;
        self.smsCountTime = true;
      }
    }, 1000);
  }
  public pwdsh() {
    this.pwdshow = this.flg ? "icons/login6.png" : "icons/login3.png";
    this.flg = !this.flg;
  }
  public nwepwdsh() {
    this.newPwdshow = this.newflg ? "icons/login6.png" : "icons/login3.png";
    this.newflg = !this.newflg;
  }
  public getImgUrl() {
    return require(`@/assets/${this.pwdshow}`);
  }
  public getNewImgUrl() {
    return require(`@/assets/${this.newPwdshow}`);
  }
}
